export default (projectId, workSpaceId) => {
    if (projectId) {
        return `project_${projectId}`;
    }
    if (workSpaceId) {
        return `workSpace_${workSpaceId}`;
    }
    return "common";
};
